import { useNavigate } from "react-router-dom";
import "../styles/OTP.css";

const OTP = () => {
  const navigate = useNavigate();
  const email = localStorage.getItem("otpEmail");

  const handleVerifyOtp = () => {
    // later: real OTP verification
    navigate("/courses");
  };

  return (
    <div className="otp-wrapper">
      <div className="otp-card">

        <h1>Check your inbox</h1>

        <p className="otp-subtitle">
          Enter the 6-digit code sent to <br />
          <strong>{email}</strong>
        </p>

        <input placeholder="6-digit code" maxLength="6" />

        <button onClick={handleVerifyOtp}>Sign up</button>

      </div>
    </div>
  );
};

export default OTP;
